import { api } from '../api';

const fetch = (bypassErrorCodes = []) => api.fetchJSON('customer', undefined, bypassErrorCodes);

// add user state to redux store with client, session and customer data
// and loading status for each one
export const customerApi = {
  fetch,
};
